import React, { useMemo } from 'react';
const ProductDetailsEditorials = (props) => {
    const renderComponent = () => {
        var _a;
        if ((_a = props.content) === null || _a === void 0 ? void 0 : _a.typeid) {
            switch (props.content.typeid) {
                case 'component_pdp_return':
                    return React.createElement(ShippingAndReturn, Object.assign({}, props));
                    break;
                case 'component_pdp_specialservices':
                    return React.createElement(SpecialServices, Object.assign({}, props));
                    break;
            }
        }
        return React.createElement(React.Fragment, null);
    };
    return renderComponent();
};
const ContentItem = (props) => {
    const { name, description } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("dt", null, name),
        React.createElement("dd", { dangerouslySetInnerHTML: { __html: description } })));
};
const ShippingAndReturn = (props) => {
    const { content } = props;
    const shippingblocks = useMemo(() => {
        var _a;
        return (_a = content === null || content === void 0 ? void 0 : content.regions) === null || _a === void 0 ? void 0 : _a.shippingblocks.components;
    }, [content]);
    return (React.createElement("div", { className: "shippingandreturn" },
        React.createElement("dl", null, shippingblocks.map((block, _n) => (React.createElement(ContentItem, Object.assign({}, block, { key: _n }))))),
        React.createElement("div", { className: "returntext mt-40", dangerouslySetInnerHTML: { __html: content.returntext } })));
};
const SpecialServices = (props) => {
    const { content } = props;
    const services = useMemo(() => {
        var _a;
        return (_a = content === null || content === void 0 ? void 0 : content.regions) === null || _a === void 0 ? void 0 : _a.services.components;
    }, [content]);
    return (React.createElement("div", { className: "SpecialServices" },
        React.createElement("dl", { className: "doubled" }, services.map((block, _n) => (React.createElement(ContentItem, Object.assign({}, block, { key: _n })))))));
};
export default ProductDetailsEditorials;
